import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent
} from '@material-ui/core';
import {useSnackbar} from 'notistack';
import React, {useState} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import Loader from '@components/framework/loader/Loader';
import DragAndDrop from '@components/system/DragAndDrop/DragAndDrop';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';

interface DragAndDropAttachmentsDialogProps {
  open: boolean;
  onClose(response: 'confirm' | 'cancel'): void;
  title: string;
  file: any;
  attachFilesFn: any;
  attachedFile: null;
}

const DragAndDropAttachmentsDialog = (
  props: DragAndDropAttachmentsDialogProps
): JSX.Element => {
  const {open, onClose, title, file, attachFilesFn, attachedFile} = props;
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const [loader, setLoader] = useState<boolean>(false);

  const handleConfirm = async () => {
    if (attachedFile) {
      setLoader(true);
      try {
        await attachFilesFn(attachedFile);
        onClose('confirm'); // Close the dialog after API call is completed
      } catch (error: any) {
        enqueueSnackbar(t(error && error.message), SnackBarConfig('error'));
      } finally {
        setLoader(false); // Set loader back to false after API call (whether successful or not)
      }
    } else {
      enqueueSnackbar(
        t('TICKETING_SYSTEM.ATTACHMENTS.UPLOAD_FILE'),
        SnackBarConfig('error')
      );
    }
  };

  const renderBody = () => {
    return (
      <DragAndDrop
        title={
          <Trans
            i18nKey={'COMMON.UPLOAD_FILE'}
            components={[
              <label className="drop-title" key={'X'} />,
              <span className="drop-title" key={'Y'} />,
              <span className="drop-title" key={'Z'} />
            ]}
          />
        }
        multiple={false}
        showSelectedFile
        handleFileChange={file}
      />
    );
  };

  return (
    <Dialog
      maxWidth={'sm'}
      fullWidth={true}
      open={open}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      aria-labelledby="confirm-dialog"
      aria-describedby="confirm-dialog"
      className="import-dialog-wrapper">
      <DialogTitle disableTypography>{title}</DialogTitle>
      <DialogContent dividers>{renderBody()}</DialogContent>
      <DialogActions style={{display: 'flex'}}>
        <Button onClick={() => onClose('cancel')} disabled={loader}>
          {t('COMMON.CANCEL')}
        </Button>
        <Button
          variant={'contained'}
          onClick={handleConfirm}
          disabled={loader}
          color="primary">
          {loader ? <Loader /> : t('TICKETING_SYSTEM.ATTACHMENTS.ADD')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DragAndDropAttachmentsDialog;
